import React, { useEffect, useState } from 'react'
import { axiosPrivate } from '../../../Apis/axios';
import { Widget } from '@uploadcare/react-widget';
import uploadcareTabEffects from 'uploadcare-widget-tab-effects';
import useAuth from '../../../Hooks/useAuth';

function Create(props) {

    const UPLOAD_PUBLIC_KEY = "d56c8b8e1e84d37ee09a";

    const url = "/categories";
    const [error, setError] = useState();  
    const { auth } = useAuth();
    const [success, setSuccess] = useState();  
    const [submit, setSubmit] = useState("Create");
    const [imageValue, setImageValue] = useState("");

    const [options, setOptions] = useState();

    useEffect(()=>{
        let opt = [];

        if(props.hasOwnProperty("opt")) opt = props.opt; 

        if(opt){
            const optionsArray =  props.opt.map((item)=> {
                return (
                    <option key={item[0]} value={item[0]}>
                        {item[1]}
                    </option>
                )
            });
        
            setOptions(optionsArray)
        }
        
    }, [props])
    

    async function handleCreate(event){
        event.preventDefault();
        event.target.elements.submitBtn.disabled = true;
        setSubmit(<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Loading...</>)

        const inputValues = {
            name: event.target.elements.title.value,
            parentId: event.target.elements.parent.value,
            slug: event.target.elements.slug.value,
            description: event.target.elements.description.value
        }

        try{
            // Axios API.
            const response = await axiosPrivate.post(url, 
                JSON.stringify(inputValues), 
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );

            event.target.elements.submitBtn.disabled = false;
            setSubmit("Create");

            if ((response.status === 200) && (imageValue != "")){
                    
                const uploadsInputValues = {
                    userId: auth.userId,
                    typeId: response.data.data.id,
                    type: 'category',
                    format: 'image/url',
                    url: imageValue.cdnUrl,
                }  
                await axiosPrivate.post("/uploads", JSON.stringify(uploadsInputValues));

            }

            // Print Out Responses.
            console.log(response?.data);
            setSuccess("Category created successfully.");
            window.location.reload(false);

        }catch(e){
            event.target.elements.submitBtn.disabled = false;
            setSubmit("Create");
            setSuccess("");
            if (e.response.data.error.hasOwnProperty("errors")){
                setError(e.response.data.error.errors[0].message);
            }else{
                setError(e.response.data.error);
                console.error(e);
            }
        }
    }

  return (
    <div className="modal fade" id="categoryModal" tabIndex="-1" role="dialog" aria-labelledby="#categoryModal" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content border-0">
                    <form onSubmit={handleCreate}>
                        <div className="modal-header py-2 text-white bg-dark">
                            <h5 className="modal-title" id="exampleModalLongTitle">Create Category</h5>
                        </div>
        
                        <div className="modal-body py-3">
                        <span className="text-danger small"><b>{error}</b></span>
                        <span className="text-success small"><b>{success}</b></span>

                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="titleInput" className='font-weight-medium'>Name: <span className='text-danger'>*</span></label>
                                    <input type="text" id='titleInput' name='title' className='form-control form-control-sm'  placeholder='Category name' required />
                                </div>
                                <div className="col-md-6"></div>
                            </div>
    
                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="iconInput" className='font-weight-medium'>Slug: <span className='text-danger'>*</span></label>
                                    <input type="text" id='iconInput' name='slug' className='form-control form-control-sm'  placeholder='Category slug' required />
                                </div>
                                <div className="col-md-6"></div>
                            </div>

                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="iconInput" className='font-weight-medium'>Parent Category: <span className='text-danger'></span></label>
                                    <select name="parent" id="" className='form-control form-control-sm'>
                                        <option value={0}> None </option>
                                        {options}
                                    </select>
                                </div>
                                <div className="col-md-6"></div>
                            </div>
                            
                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="iconInput" className='font-weight-medium'>Image: <span className='text-danger'></span></label>
                                    <br />
                                    <Widget 
                                        publicKey={UPLOAD_PUBLIC_KEY}
                                        tabs='file'
                                        customTabs={{preview: uploadcareTabEffects}}
                                        previewStep='true'
                                        imagesOnly='true'
                                        multiple='true'
                                        multipleMax='1'
                                        effects='crop'
                                        multipartPartSize='10480'
                                        onChange={(file) => setImageValue(file)}
                                        crop='free, 16:9, 4:3, 5:4, 1:1'
                                        required
                                    />
                                </div>
                                <div className="col-md-6"></div>
                            </div>
    
                            <div className="row py-2">
                                <div className="col-md-10">
                                    <label htmlFor="descInput" className='font-weight-medium'>Description: </label>
                                    <textarea className='form-control form-control-sm' name="description" id="descInput" cols="30" rows="3"></textarea>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                        </div>

                        <div className="modal-footer py-1">
                            <button type="button" className="btn btn-sm btn-dark" data-dismiss="modal" aria-label="Close">Close</button>
                            <button type="submit" name="submitBtn" className="btn btn-danger btn-sm">
                                {submit}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
  );
}

export default Create;
